import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Card from "./card";

class Related extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: []
    };

    this.renderRelated = this.renderRelated.bind(this);
  }

  componentDidMount() {
    this.renderRelated();
  }

  componentDidUpdate() {
    const related = document.querySelector(".related-c");
    window.dispatchEvent(new CustomEvent("UpdateRightRailMargin", {
      detail: related?.offsetHeight || 0
    }))
  }

  renderRelated() {
    axios
      .get(this.props.api.related)
      .then(results => {
        this.setState({
          data: results.data.Results
        });
      })
      .catch(err => {
        throw err;
      });
  }

  render() {
    return this.state.data.length > 0 ? (
      <div className="related-list">
        <h3 className="related-list__title">YOU MAY ALSO LIKE:</h3>
        <div className="related-list__cards">
          {this.state.data.map(card => (
            <Card
              key={card.ItemID}
              title={card.Title}
              pageUrl={card.PageURL}
              image={card.ArticleThumbnail || card.ArticleImage}
              video={card.ArticleVideo}
              videoThumbnail={card.ArticleThumbnail}
            />
          ))}
        </div>
      </div>
    ) : null;
  }
}

Related.propTypes = {
  api: PropTypes.object
};

export default Related;
